import { render, staticRenderFns } from "./DesktopPage.vue?vue&type=template&id=3d3643a1&scoped=true"
import script from "./DesktopPage.vue?vue&type=script&lang=js"
export * from "./DesktopPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopPage.vue?vue&type=style&index=0&id=3d3643a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3643a1",
  null
  
)

export default component.exports